<template>
  <div class="mb-3" v-if="schedule">
    <!-- 필답 평가 과락자 목록 -->
    <div v-if="schedule.fail.writing.length > 0" class="my-3">
      <div class="bolder"><mdb-icon icon="highlighter"/> 필답평가 과락자</div>
      <div v-for="(w,ix) in schedule.fail.writing" :key="ix">
        <mdb-badge  style="font-size:12px">{{w.lecture}}</mdb-badge>
        <span v-for="(s, wx) in w.list" :key="s+wx" style="font-size:14px  ">
          {{s.name}}({{s.score}}<span v-if="s.score2">/{{s.score2}}</span>),
        </span>
      </div>
    </div>
    <!-- 수행 평가 과락자 목록 -->
    <div v-if="schedule.fail.perform.length > 0" class="mt-4">
      <div class="bolder"><mdb-icon icon="highlighter"/> 수행 평가 과락자</div>
      <div v-for="(p, ix) in schedule.fail.perform" :key="ix">
        <mdb-badge style="font-size:12px">{{p.lecture}}</mdb-badge>
        <span v-for="(s, sx) in p.list" :key="s+sx" style="font-size:14px  ">
          {{s.name}}({{s.score}}<span v-if="s.score2">/{{s.score2}}</span>),
        </span>
      </div>
    </div>

    <!-- 미제출자  -->
    <div v-if="schedule.missing.writing.length > 0" class="mt-4">
      <div class="bolder"><mdb-icon icon="highlighter"/> 필답평가 미 응시자</div>
      <div v-for="(p, ix) in schedule.missing.writing" :key="ix">
        <mdb-badge style="font-size:12px">{{p.name}}</mdb-badge>
        <span v-for="(s, sx) in p.students" :key="s+sx" style="font-size:14px  ">
          {{s}},
        </span>
      </div>
    </div>
    <!-- 수행 미제출자  -->
    <div v-if="schedule.missing.perform.length > 0" class="mt-4">
      <div class="bolder"><mdb-icon icon="highlighter"/> 수행평가 미 응시자</div>
      <div v-for="(p,ix) in schedule.missing.perform" :key="ix">
        <mdb-badge style="font-size:12px">{{p.name}}</mdb-badge>
        <span v-for="(s, sx) in p.students" :key="s+sx" style="font-size:14px  ">
          {{s}},
        </span>
      </div>
    </div>
    <!-- 포트폴리오 미제출자  -->
    <div v-if="schedule.missing.portfolio.length > 0" class="mt-4">
      <div class="bolder"><mdb-icon icon="highlighter"/> 포트폴리오 미 응시자</div>
      <div v-for="(p,ix) in schedule.missing.portfolio" :key="ix">
        <mdb-badge style="font-size:12px">{{p.name}}</mdb-badge>
        <span v-for="(s, sx) in p.students" :key="s+sx" style="font-size:14px  ">
          {{s}},
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import { } from 'mdbvue';
import Summary from '@/models/Summary';
import { mapState } from 'vuex';
export default {
  name: 'StaffFailMissingSummary',
  components: {},
  props: [],
  data: () => ({
    TAG: 'StaffFailMissingSummary :',
    schedule: undefined
  }),
  computed: {
    ...mapState('training', ['training'])
  },
  methods: {
    async load () {
      if (!this.training._id) return
      const query = { training: this.training._id, failScore: this.training.failScore }
      this.schedule = await Summary.getSchedule(query)
    }
  },
  watch: { training () { this.load() } },
  created () { this.load() }
}
</script>
